import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService as AuthGuard } from '@app/core';
import { ErrorPageComponent } from '@app/shared';

// import { ProductSearchComponent  }   from './product-search/product-search.component';

//import { DashboardModule }      from './dashboard/dashboard.module';


const routes: Routes = [

  // { path: 'search', component: ProductSearchComponent, canActivate: [AuthGuard], data: { state: 'search' } },
  // { path: 'detail/:uuid', component: ProductDetailComponent, canActivate: [AuthGuard], data: { state: 'detail' } },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: '@app/auth/auth.module#AuthModule'
  },
  {
    path: 'main',
    loadChildren: '@app/manager/manager.module#ManagerModule',
    canActivate: [AuthGuard],
  },
  {
    path: 'studio',
    loadChildren: '@app/studio/studio.module#StudioModule',
    canActivate: [AuthGuard]
  },
  {
    path: 'account',
    loadChildren: '@app/account/account.module#AccountModule',
    canActivate: [AuthGuard]
  },
  { path: 'error', component: ErrorPageComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes,{ useHash: true }) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/app-routing.module.ts